window.GOOGLE_CAPTCHA_SITE_KEY = '6Lc62DohAAAAAL194cwpjx7uSbEv-i78M3OUAP_l';

$(document).scroll(function() {
    styleTrigger = window.scrollY > $('[data-header-scroll]').height();
    
    $('header').toggleClass('header_scroll', styleTrigger);
})

$('[data-form]').on('submit', function(e){
    e.preventDefault();
    const form = $(this);
    const path = '/wp-content/themes/createvenue/sendForm.php';

    grecaptcha.ready(function () {
        grecaptcha.execute(GOOGLE_CAPTCHA_SITE_KEY, { action: 'submit' }).then(
            token => {
                $(form).find('#gre_token').val(token);

                $.post(path, $(form).serialize(), function( data ) {
                    if(data.match(/OK/)){
                        $('#submitForm').val('Sent');
                        $('#submitForm').prop('disabled', true);

                        var myModal = new bootstrap.Modal(document.getElementById('getQuote'), {
                            keyboard: false
                          })
                        }

                        myModal.hide()
                  });
            }
        );
    });

})